import { useApolloClient, useLazyQuery, gql } from '@apollo/client';
import { Block } from '@bechtel/types';
import { GET_BLOCK_BY_ID } from '@bechtel/client-gql';

export function useBlockCache() {
  const [getBlockById] = useLazyQuery<{ blockById: Block }, { id: string }>(GET_BLOCK_BY_ID, {
    fetchPolicy: 'network-only',
  });
  const client = useApolloClient();

  const updateBlockCache = (blockId: string) => {
    if (!blockId) return;
    const cachedBlock = client.readFragment({
      id: 'Block:' + blockId,
      fragment: gql`
        fragment block on Block {
          id
        }
      `,
    });
    if (!cachedBlock) return;

    getBlockById({
      variables: {
        id: blockId,
      },
    });
  };
  return { updateBlockCache };
}
